import {
  MdAutorenew,
  MdSportsGymnastics,
  MdLock,
  MdSpa,
  MdAir,
  MdMusicNote,
  MdSelfImprovement,
  MdCheckroom,
  MdMoreHoriz,
} from 'react-icons/md';

/** Shared serial / name / phone / CNIC search copy (Guest Pass + Renewal + ancillary sales). */
export const MEMBER_SEARCH_PLACEHOLDER = 'Search serial no, name, phone, or CNIC...';
export const MEMBER_SEARCH_LABEL = 'Member (Serial No / name / phone / CNIC)';

/** Ancillary sale pages shown after Guest Pass in receptionist sidebar. */
export const RECEPTIONIST_SALE_PAGES = [
  {
    id: 'renewal-sale',
    path: '/receptionist/renewal-sale',
    route: 'renewal-sale',
    label: 'Renewal Sale',
    icon: MdAutorenew,
    source: 'renewal_sale',
    title: 'Renewal Sale',
    subtitle: 'Record membership renewal payments',
    itemLabel: 'Renewal package / note',
    itemPlaceholder: 'e.g. Premium renewal',
  },
  {
    id: 'pt-sale',
    path: '/receptionist/pt-sale',
    route: 'pt-sale',
    label: 'PT Sale',
    icon: MdSportsGymnastics,
    source: 'pt_sale',
    title: 'PT Sale',
    subtitle: 'Record personal training sales',
    itemLabel: 'Trainer',
    itemPlaceholder: 'Select or type trainer name',
    /** Store trainer name in payments.package_name (no new DB column). */
    itemIsTrainer: true,
  },
  {
    id: 'locker-sale',
    path: '/receptionist/locker-sale',
    route: 'locker-sale',
    label: 'Locker Sale',
    icon: MdLock,
    source: 'locker_sale',
    title: 'Locker Sale',
    subtitle: 'Record locker rental sales',
    itemLabel: 'Locker / plan',
    itemPlaceholder: 'e.g. Medium locker — monthly',
  },
  {
    id: 'spa-sale',
    path: '/receptionist/spa-sale',
    route: 'spa-sale',
    label: 'Spa Sale',
    icon: MdSpa,
    source: 'spa_sale',
    title: 'Spa Sale',
    subtitle: 'Record spa service sales',
    itemLabel: 'Spa service',
    itemPlaceholder: 'e.g. Massage 60 min',
    /** Same complimentary checkbox as New Membership / Subscription. */
    allowComplimentary: true,
  },
  {
    id: 'oxybar-sale',
    path: '/receptionist/oxybar-sale',
    route: 'oxybar-sale',
    label: 'Oxybar Sale',
    icon: MdAir,
    source: 'oxybar_sale',
    title: 'Oxybar Sale',
    subtitle: 'Record oxybar sales',
    itemLabel: 'Oxybar item',
    itemPlaceholder: 'e.g. Oxygen session',
  },
  {
    id: 'zumba-sale',
    path: '/receptionist/zumba-sale',
    route: 'zumba-sale',
    label: 'Zumba Sale',
    icon: MdMusicNote,
    source: 'zumba_sale',
    title: 'Zumba Sale',
    subtitle: 'Record Zumba class sales',
    itemLabel: 'Trainer',
    itemPlaceholder: 'Select or type trainer name',
    itemIsTrainer: true,
  },
  {
    id: 'yoga-sale',
    path: '/receptionist/yoga-sale',
    route: 'yoga-sale',
    label: 'Yoga Sale',
    icon: MdSelfImprovement,
    source: 'yoga_sale',
    title: 'Yoga Sale',
    subtitle: 'Record yoga class sales',
    itemLabel: 'Trainer',
    itemPlaceholder: 'Select or type trainer name',
    itemIsTrainer: true,
  },
  {
    id: 'gym-apparel',
    path: '/receptionist/gym-apparel',
    route: 'gym-apparel',
    label: 'Gym Apparel',
    icon: MdCheckroom,
    source: 'gym_apparel',
    title: 'Gym Apparel',
    subtitle: 'Record apparel and merchandise sales',
    itemLabel: 'Item',
    itemPlaceholder: 'e.g. T-shirt / bottle',
  },
  {
    id: 'miscellaneous-sale',
    path: '/receptionist/miscellaneous-sale',
    route: 'miscellaneous-sale',
    label: 'Miscellaneous Sale',
    icon: MdMoreHoriz,
    source: 'miscellaneous_sale',
    title: 'Miscellaneous Sale',
    subtitle: 'Record other walk-in and misc sales',
    itemLabel: 'Sale description',
    itemPlaceholder: 'e.g. Day towel / other',
  },
];

export function getSalePageConfig(routeOrId) {
  return RECEPTIONIST_SALE_PAGES.find(
    (p) => p.route === routeOrId || p.id === routeOrId || p.path.endsWith(`/${routeOrId}`),
  ) || null;
}

/** Clone sale pages with a different URL prefix (e.g. /admin). Receptionist paths stay unchanged. */
export function salePagesForBase(base) {
  const prefix = String(base || '').replace(/\/$/, '');
  return RECEPTIONIST_SALE_PAGES.map((p) => ({ ...p, path: `${prefix}/${p.route}` }));
}
